export const genderOptions = [
  { value: 'masculino', label: 'Masculino' },
  { value: 'femenino', label: 'Femenino' }
];

export const employmentOptions = [
  { value: 'empleado_privado', label: 'Empleado Privado' },
  { value: 'empleado_publico', label: 'Empleado Público' },
  { value: 'jubilado', label: 'Jubilado' },
  { value: 'pensionado', label: 'Pensionado' },
  { value: 'monotributista_autonomo', label: 'Monotributista/Autónomo' },
  { value: 'ayuda_estatal', label: 'Ayuda Estatal' },
];


export const bankOptions = [
  { value: '262', label: 'Banco America', cirenioId: 27, openBankingEnabled: false },
  { value: '017', label: 'Banco BBVA Frances', cirenioId: 6, openBankingEnabled: true },
  { value: '322', label: 'Banco Bind', cirenioId: 42, openBankingEnabled: false },
  { value: '311', label: 'Banco de Chaco', cirenioId: 37, openBankingEnabled: false },
  { value: '309', label: 'Banco de La Rioja', cirenioId: 35, openBankingEnabled: false },
  { value: '029', label: 'Banco Ciudad', cirenioId: 9, openBankingEnabled: false },
  { value: '389', label: 'Banco Columbia', cirenioId: 49, openBankingEnabled: false },
  { value: '299', label: 'Banco Comafi', cirenioId: 33, openBankingEnabled: false },
  { value: '094', label: 'Banco Corrientes', cirenioId: 19, openBankingEnabled: false },
  { value: '191', label: 'Banco Credicoop', cirenioId: 22, openBankingEnabled: false },
  { value: '083', label: 'Banco Chubut', cirenioId: 16, openBankingEnabled: true },
  { value: '310', label: 'Banco Del SOL', cirenioId: 36, openBankingEnabled: false },
  { value: '386', label: 'Banco Entre Ríos', cirenioId: 71, openBankingEnabled: true },
  { value: '315', label: 'Banco Formosa', cirenioId: 39, openBankingEnabled: true },
  { value: '007', label: 'Banco Galicia', cirenioId: 1, openBankingEnabled: true },
  { value: '044', label: 'Banco Hipotecario', cirenioId: 11, openBankingEnabled: true },
  { value: '150', label: 'Banco HSBC', cirenioId: 21, openBankingEnabled: false },
  { value: '015', label: 'Banco ICBC', cirenioId: 4, openBankingEnabled: false },
  { value: '259', label: 'Banco Itaú', cirenioId: 26, openBankingEnabled: false },
  { value: '093', label: 'Banco La Pampa', cirenioId: 18, openBankingEnabled: false },
  { value: '285', label: 'Banco Macro', cirenioId: 32, openBankingEnabled: true },
  { value: '254', label: 'Banco Mariva', cirenioId: 25, openBankingEnabled: false },
  { value: '281', label: 'Banco Meridian', cirenioId: 31, openBankingEnabled: false },
  { value: '011', label: 'Banco Nación', cirenioId: 2, openBankingEnabled: true },
  { value: '097', label: 'Banco Neuquén', cirenioId: 20, openBankingEnabled: false },
  { value: '034', label: 'Banco Patagonia', cirenioId: 10, openBankingEnabled: true },
  { value: '301', label: 'Banco Piano', cirenioId: 34, openBankingEnabled: false },
  { value: '014', label: 'Banco Provincia BS AS', cirenioId: 3, openBankingEnabled: true },
  { value: '247', label: 'Banco Roela', cirenioId: 24, openBankingEnabled: false },
  { value: '065', label: 'Banco Rosario', cirenioId: 14, openBankingEnabled: false },
  { value: '277', label: 'Banco Saenz', cirenioId: 30, openBankingEnabled: false },
  { value: '045', label: 'Banco San Juan', cirenioId: 12, openBankingEnabled: true },
  { value: '072', label: 'Banco Santander', cirenioId: 15, openBankingEnabled: true },
  { value: '330', label: 'Banco Santa Cruz', cirenioId: 76, openBankingEnabled: true },
  { value: '086', label: 'Banco Santa Fe', cirenioId: 72, openBankingEnabled: true },
  { value: '321', label: 'Banco Santiago del Estero', cirenioId: 41, openBankingEnabled: false },
  { value: '027', label: 'Banco Supervielle', cirenioId: 8, openBankingEnabled: false },
  { value: '268', label: 'Banco Tierra del Fuego', cirenioId: 28, openBankingEnabled: false },
  { value: '060', label: 'Banco Tucuman', cirenioId: 13, openBankingEnabled: false },
  { value: '341', label: 'Banco VOII', cirenioId: 38, openBankingEnabled: false },
  { value: '016', label: 'Citi Bank', cirenioId: 5, openBankingEnabled: false },
  { value: '198', label: 'Valores SA', cirenioId: 23, openBankingEnabled: false },
  { value: '020', label: 'Bancor', cirenioId: 7, openBankingEnabled: true },
  // { value: '999', label: 'Bica', cirenioId: 50, openBankingEnabled: false }
];


export const areaCodes = [
  { value: '11', label: 'Buenos Aires' },
  { value: '3833', label: 'Catamarca' },
  { value: '362', label: 'Chaco' },
  { value: '297', label: 'Chubut' },
  { value: '351', label: 'Córdoba' },
  { value: '3783', label: 'Corrientes' },
  { value: '343', label: 'Entre Ríos' },
  { value: '3717', label: 'Formosa' },
  { value: '388', label: 'Jujuy' },
  { value: '2954', label: 'La Pampa' },
  { value: '3822', label: 'La Rioja' },
  { value: '261', label: 'Mendoza' },
  { value: '376', label: 'Misiones' },
  { value: '299', label: 'Neuquén' },
  { value: '2920', label: 'Río Negro' },
  { value: '387', label: 'Salta' },
  { value: '264', label: 'San Juan' },
  { value: '266', label: 'San Luis' },
  { value: '2962', label: 'Santa Cruz' },
  { value: '342', label: 'Santa Fe' },
  { value: '385', label: 'Santiago del Estero' },
  { value: '2901', label: 'Tierra del Fuego' },
  { value: '381', label: 'Tucumán' }
];


export const provinceOptions = [
  { value: '2', label: 'Buenos Aires' },
  { value: '3', label: 'Capital Federal' },
  { value: '10', label: 'Catamarca' },
  { value: '8', label: 'Chaco' },
  { value: '19', label: 'Chubut' },
  { value: '22', label: 'Córdoba' },
  { value: '21', label: 'Corrientes' },
  { value: '5', label: 'Entre Ríos' },
  { value: '14', label: 'Formosa' },
  { value: '23', label: 'Jujuy' },
  { value: '11', label: 'La Pampa' },
  { value: '6', label: 'La Rioja' },
  { value: '12', label: 'Mendoza' },
  { value: '13', label: 'Misiones' },
  { value: '15', label: 'Neuquén' },
  { value: '16', label: 'Río Negro' },
  { value: '1', label: 'Salta' },
  { value: '9', label: 'San Juan' },
  { value: '4', label: 'San Luis' },
  { value: '24', label: 'Santa Cruz' },
  { value: '17', label: 'Santa Fe' },
  { value: '7', label: 'Santiago del Estero' },
  { value: '20', label: 'Tierra del Fuego' },
  { value: '18', label: 'Tucumán' }
];